import {ApiClientFactoryInterface, ApiClientFactory} from "./clients";
import {Headers} from "../types";
import {SurveyProvider} from "../SurveyProvider";

export class SurveyProviderFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v1/survey`,
      headers
    );
  }

  public createSurveyProvider(token: string): SurveyProvider {
    return new SurveyProvider(this.apiClientFactory.createAuthorizedClient(token));
  }
}